module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_net_URLLoader__;